export default "__VITE_ASSET__DQvGhyzS__"